/**
 * Created by Administrator on 2017-09-01.
 */
import React,{Component} from 'react'


import '../components_css/pc.css'



export default class App extends Component{
  render(){
    return(
     <div id="rootIn">
       {this.props.children}
       
     </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/app.js